import { useCallback, useState } from "react";
import { FILTER_VALUES } from "@/constants/filters";
import { USAGE_VIEW_TYPES } from "@/constants/usage";
/** managing usage filter state */ export const useUsageFilters = ()=>{
    const [filters, setFilters] = useState({
        viewType: USAGE_VIEW_TYPES.HOURLY,
        selectedDate: new Date().toISOString().split("T")[0],
        startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
        endDate: new Date().toISOString().split("T")[0],
        selectedApiKey: FILTER_VALUES.ALL
    });
    // Pure function to update a specific filter
    const updateFilter = useCallback((key, value)=>{
        setFilters((prev)=>({
                ...prev,
                [key]: value
            }));
    }, []);
    // Convenience function to update multiple filters at once
    const updateFilters = useCallback((updates)=>{
        setFilters((prev)=>({
                ...prev,
                ...updates
            }));
    }, []);
    // Switch view type without changing dates
    const setViewType = useCallback((viewType)=>{
        setFilters((prev)=>({
                ...prev,
                viewType
            }));
    }, []);
    // Set date range (for daily view)
    const setDateRange = useCallback((startDate, endDate)=>{
        setFilters((prev)=>({
                ...prev,
                startDate,
                endDate
            }));
    }, []);
    // Set single date (for hourly view)
    const setSelectedDate = useCallback((selectedDate)=>{
        setFilters((prev)=>({
                ...prev,
                selectedDate
            }));
    }, []);
    // Set API key filter
    const setSelectedApiKey = useCallback((selectedApiKey)=>{
        updateFilter("selectedApiKey", selectedApiKey);
    }, [
        updateFilter
    ]);
    return {
        filters,
        updateFilter,
        updateFilters,
        setViewType,
        setDateRange,
        setSelectedDate,
        setSelectedApiKey
    };
};
